import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { Space, Button, Form, Alert, Upload, Row, Col, message, Divider } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import * as Yup from 'yup';
import * as constants from '../constants';
import { isEmpty } from 'lodash'
import qs from 'query-string';

import {
    createNewIncident, uploadIncidentFile
} from '../actions';

import uistate from '../../uistate';
import globalappstate from '../../globalappstate';
import common from '../../../common';
import core from '../../core';
import currentuser from '../../currentuser';


const { SelectInput, TextInput, TextArea, DatePickerInput, DisplayFormikState } = core;
const ButtonGroup = Button.Group;
const FormItem = Form.Item;

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
}

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 6,
        },
    },
};


class NewIncidentForm extends Component {

    state = {
        fileList: [],
        uploading: false,
        fileError: '',
        source: 'https://ballastnedam.sharepoint.com/sites/intranet-nl'
    }

    UNSAFE_componentWillMount() {
        let appsettings = {
            lang: 1043,
            detailwidth: 50
        };
        let queryparams = qs.parse(this.props.location.search);
        if (queryparams.lang) {
            appsettings.lang = parseInt(queryparams.lang, 10);
        }
        if (queryparams.source) {
            this.setState({ source: queryparams.source });
        }
        this.props.saveAppSettings(appsettings);
        this.props.loadLabels();
        this.props.loadUserSettings();
        this.props.fetchStartupData();
    }

    redirectToSource = () => {
        window.location.href = this.state.source;
    }

    onSave = async (values, { setSubmitting, setErrors }) => {
        try {
            if (this.state.fileList.length < 1) {
                await this.props.createNewIncident(values);
                message.success(this.label('IncidentSubmittedDone'));
                setTimeout(this.redirectToSource, 2000);
            } else {
                let newid = await this.props.createNewIncident(values);
                message.success(this.label('IncidentSubmitted'));
                message.info(this.label('UploadingAttachment'))
                await this.props.uploadIncidentFile(this.state.fileList[0], newid);
                message.success(this.label('AttachmentSavedDone'));
                setTimeout(this.redirectToSource, 2000);
            }
        } catch (error) {
            setSubmitting(false);
            setErrors();
        }
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'NewIncidentForm', key);
    }

    FormSchema = () => {
        let schema = Yup.object().shape({
            subject: Yup.string().required('*'),
            date: Yup.date().required('*'),
            email: Yup.string().email(this.label('NoValidEmail')),
            idIncidentType: Yup.number().integer().required('*'),
        })

        return schema;
    }

    handleCancel = () => this.setState({ previewVisible: false });


    CreateForm = (props) => {
        const { fileList } = this.state;
        const fprops = {
            onRemove: (file) => {
                this.setState((state) => {
                    const index = state.fileList.indexOf(file);
                    const newFileList = state.fileList.slice();
                    newFileList.splice(index, 1);
                    return {
                        fileList: newFileList,
                    };
                });
            },
            beforeUpload: (file) => {
                this.setState(state => ({
                    fileList: [file],
                }));
                return false;
            },
            fileList,
        };

        return (
            <Row justify="center">
                <Col span={16}>
                    <Divider>{this.label("Title")}</Divider>
                    <Form layout='horizontal' style={{ margin: 10 }}>


                        <TextInput {...props} name="subject" label={this.label("Subject")} formItemLayout={formItemLayout} />
                        <TextInput {...props} name="phone" label={this.label("Phone")} formItemLayout={formItemLayout} />
                        <TextInput {...props} name="email" label={this.label("Email")} formItemLayout={formItemLayout} />
                        <DatePickerInput {...props} name="date" showTime={false} label={this.label("Date")} formItemLayout={formItemLayout} />
                        <SelectInput {...props} name="idIncidentType" nameField="name" idField="id" items={this.props.picklists.incidentTypes} label={this.label("IncidentType")} formItemLayout={formItemLayout} />

                        <TextArea {...props} name="description" label={this.label("Description")} rows={5} formItemLayout={formItemLayout} />

                        <Form.Item label={this.label("File")}{...formItemLayout} hasFeedback={this.state.fileList.length < 1} validateStatus={this.state.fileError}>
                            <Upload {...fprops}>
                                <Button>
                                    <UploadOutlined /> {this.label("SelectFile")}
                                </Button>
                            </Upload>
                        </Form.Item>

                        <br />

                        <FormItem {...tailFormItemLayout}>
                            <ButtonGroup className='entity-form-btns'>
                                <Button disabled={props.isSubmitting} onClick={this.redirectToSource}>{this.label("Cancel")} </Button>
                                <Button type="primary" onClick={() => props.handleSubmit()} disabled={props.isSubmitting} > {this.label("Save")} </Button>
                            </ButtonGroup>
                        </FormItem>
                        {props.isSubmitting &&
                            <Alert
                                message={this.label("Saving")}
                                style={{ marginTop: 20 }}
                            />
                        }
                        {/* <DisplayFormikState {...props} /> */}
                    </Form>
                </Col>
            </Row>
        )
    }

    render() {
        if (isEmpty(this.props.picklists) || isEmpty(this.props.labels)) {
            return (<div>loading...</div>);
        } else {
            return (
                <Formik validateOnBlur={false} validateOnChange={false}
                    initialValues={{ date: new Date() }}
                    validationSchema={this.FormSchema()}
                    onSubmit={this.onSave}
                    innerRef={p => (this.formik = p)}
                >
                    {(props) => this.CreateForm(props)}
                </Formik>
            );
        }
    }
}
function mapStateToProps(state) {
    return {
        picklists: globalappstate.selectors.allPicklists(state),
        labels: uistate.selectors.uiLabels(state),
    };
}


export default connect(mapStateToProps, {
    saveAppSettings: uistate.actions.saveAppSettings,
    fetchStartupData: currentuser.actions.fetchStartupData,
    loadUserSettings: uistate.actions.loadUserSettings,
    loadLabels: uistate.actions.loadLabels,
    createNewIncident,
    uploadIncidentFile,
})(NewIncidentForm);


